import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { CircularLoading } from '../../Common';
import { trakrefFontFamilySemiBold } from '../../../utils.js';
import { Grey1 } from '../../../color_utils.js';
import Routes from '../../../routes.js';
import Text from '../../../Utils/Util_Components/Translator';
import NoTableDataIcon from '../../../Icons/empty_table_placeholder.svg';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../Table/Table.css';

const SubTable = ({
    parentEntityId,
    columns,
}) => {
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const res = await fetch(Routes.WorkOrder.ServiceEventSubTable(parentEntityId));
            const data = await res.json();
            const { rows } = data;
            setRows(rows);
            setLoading(false);
        };

        fetchData();
    }, [parentEntityId]);

    if (loading) {
        return <CircularLoading />;
    }

    if (rows.length <= 0) {
        return (
            <Card variant='outlined'>
                <Grid container>
                    <Grid item xs={12} align='center'>
                        <img
                            style={{ padding: '1% 0%' }}
                            src={NoTableDataIcon}
                            alt="No Service Events"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant='h5'
                            align='center'
                            style={{
                                marginBottom: '1%',
                                color: Grey1,
                                fontFamily: trakrefFontFamilySemiBold,
                            }}
                        >
                            No Service Events
                        </Typography>
                </Grid>
                </Grid>
            </Card>
        );
    }

    return (
        <DataGridPro
            pagination
            disableRowSelectionOnClick
            rows={rows}
            columns={columns}
            loading={loading}
            columnHeaderHeight={45}
            slotProps={{
                loadingOverlay: {
                    variant: 'linear-progress',
                    noRowsVariant: 'linear-progress',
                },
            }}
            getRowClassName={params => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
        />
    );
};

SubTable.propTypes = {
    parentEntityId: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired
};

export default SubTable;
